import EPrescriptionQuotation from 'Components/e-prescription/forms/e-prescription-quotation/e-prescription-quotation';
import React from 'react';
import './upload-e-prescription.scss';

type Props = {};

const UploadEPrescription = (props: Props) => {
  return (
    <div className="upload-e-prescription">
      
      <div className="gradient-bg" />
      <div className="upload-e-prescription__page-wrapper">
        <EPrescriptionQuotation />
      </div>
    </div>
  );
};

export default UploadEPrescription;
